import { useEffect, useState } from "react";
import { IoStarOutline } from "react-icons/io5";
import { FaGithub } from "react-icons/fa";
import { useDatabase } from "../../hooks/useDatabase";

import './githubProjects.css';

interface GithubProject {
    id: number,
    name: string,
    full_name: string,
    updated_at: Date,
    description: string,
    stargazers_count: number,
    language: string,
    homepage: string,
    github_url: string
}

export default function GithubProjects() {

    const [ projects, setProjects ] = useState<GithubProject[]>([]);
    const db = useDatabase();

    useEffect(() => {
        async function getProjects() {
            const projects = await fetch("https://api.github.com/search/repositories?q=topic:portfolio-project+user:callum411");
            const data = await projects.json();

            if (data !== null && data.items && data.items.length > 0) {
                const mappedRepos: GithubProject[] = data.items.map((repo: any) => ({
                    id: repo.id,
                    full_name: repo.full_name,
                    name: repo.name,
                    updated_at: repo.updated_at,
                    description: repo.description,
                    stargazers_count: repo.stargazers_count,
                    language: repo.language,
                    homepage: repo.homepage,
                    github_url: repo.html_url
                }));
                setProjects(mappedRepos);
            } else {
                const mappedRepos: GithubProject[] = db.sections.githubProjects.map((repo: any) => ({
                    id: repo.id,
                    full_name: repo.full_name,
                    name: repo.name,
                    updated_at: repo.updated_at,
                    description: repo.description,
                    stargazers_count: repo.stargazers_count,
                    language: repo.language,
                    homepage: repo.homepage,
                    github_url: repo.html_url
                }));
                setProjects(mappedRepos);
            }
        }

        getProjects();
    }, [])

    return (
        <>
            {projects !== null && projects.length > 0 ? <section className="github-projects light" id="github-projects">
                <div className="inner">
                    <h2>Projects</h2>
                    <p>Here's some projects from my Github!</p>

                    <div className="cols span-2">
                        {projects.map((p, i) => {
                            return <div className="col">
                                <div className="github-project">
                                    <div className="group">
                                        <FaGithub className="gh-icon" />
                                        <a href={p.github_url} target="_blank">{p.full_name}</a>
                                    </div>

                                    <div className="group">
                                        <div className="language">{p.language}</div>
                                        <p>{p.description}</p>
                                    </div>

                                    <div className="icon-list">
                                        <div className="icon"><IoStarOutline /> {p.stargazers_count}</div>
                                    </div>

                                    <a href={p.homepage} target="_blank" className="btn">View</a>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </section> : <>No projects found</>}
        </>
    );
}